<script lang="ts">
    import { bind, loop_guard } from "svelte/internal";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiCheckbox from "../../naui/atoms/NauiCheckbox.svelte";
    import NauiCheckboxGroup from "../../naui/atoms/NauiCheckboxGroup.svelte";
    import { currency, percent } from "../../utils";
    import { itemMapper, validateColumns } from "../utils";
    import NauiField from "../../naui/atoms/NauiField.svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import {createEventDispatcher} from "svelte";
    import {ItemPrice} from "../../interfaces/item-price.class";
    // import type { IProduct } from "../../interfaces/product.interface";
    // import CargarMaestra from "../maestras/CargarMaestra.svelte";
    // import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
   
    // import { fade } from "svelte/transition";
    // import  {ConfirmModal}  "./modals/ModalCanvas.svelte"
    
   

    export let precios = [];
    export let item: ItemPrice;
    export let editable: boolean = false;
    export let canApprove: boolean = false;
    const dispatcher = createEventDispatcher();
    

    export let option_input: string;
    export let manual_increment: number;
    export let checkbox: boolean;
    export let preciosFiltered: any;
    export let userInputTextMessage: any;  

    export let modalApp;

    export let currentPage = 1;
    export let itemsPerPage = 10;
    export let nPages = 5;

    export let itemsPerPageOptions = []; // Otras opciones pueden ser agregadas según tus necesidades

    $: endIndex = nPages;
    $: currentPage = currentPage;
      
  const updatePage = (newPage) => {
    newPage = Math.max(1, Math.min(newPage, Math.ceil(nPages)));
    let data = {
        currentPage: newPage,
        itemsPerPage: itemsPerPage,
        nPages: nPages
    }

    dispatcher('updatePage', data);
    // Lógica adicional para cargar datos de la nueva página, si es necesario
  };

    function apply() {
        precios.forEach(
            function (item){
                if(item.checkbox){

                    if(option_input == "price-A"){
                        item._suggestedMUOfferPrice = item.product?.abc?.A
                    }

                    else if(option_input == "price-B"){
                        
                        item._suggestedMUOfferPrice = item.product?.abc?.B
                    }

                    else if(option_input == "price-C"){
                        item._suggestedMUOfferPrice = item.product?.abc?.C
                    }

                    else if(option_input == "price-Min"){
                        item._suggestedMUOfferPrice = item?.product?.min_price
                    }

                    else if(option_input == "incremento-directorio"){
                        item._suggestedMUOfferPrice = (item?.product?.sap?.priceSold | 0) * ( 1 + item?.IncreasePriceSoldPreviousYear)
                    }

                    else if(option_input == "incremento-manual-directorio"){
                        item._suggestedMUOfferPrice = (item?.product?.sap?.priceSold | 0) * ( 1 + manual_increment/100)
                    }

                    else if(option_input == "precio-general"){
                        
                        item._suggestedMUOfferPrice = item.product?.sap?.current | 0
                    }

                    
                }
                return item
            } 
        )
        $: precios = precios;
        $: item._suggestedMUOfferPrice = item._suggestedMUOfferPrice

    };


  function applyConfirm() {
    preciosFiltered = precios.filter(x=> x.checkbox)
    preciosFiltered = preciosFiltered.map((x: { id: any; })=> x.id);
    
    if (preciosFiltered.length > 0 && option_input != undefined) {
        modalApp.openConfirmModal({
            title: 'Confirmación',
            message: '¿Esta accion insertara los los precios seleccionados en la casilla de Precio Unitario Sugerido, una vez ahí, podra hacer click en Confirmar los precios',
            ok: 'ACEPTAR',
            cancel: 'CANCELAR',
            onAccept: () => {
                apply()
            },
            onCancel: () => {
            
            }
         });

        } else {
        
        let message = "No hay tipo de precio seleccionado"
        if(preciosFiltered.length == 0) {
            message = "No hay items seleccionados"
            
        }
        alert(message);

    }

}





    function confirm() {
        precios.forEach(
            function (item){
                if(item.checkbox){
                    item.muOfferPrice = item._suggestedMUOfferPrice
                }
    })

    $: precios = precios;
}




    function validateAlert(alert: boolean){
        if (alert) return "⚠️ Alerta"

        return ""
    }

    function reject() {
        dispatcher('sendApproval', {
            id: item.id,
            status: {
                label: 'RECHAZAR',
                action: {
                    label: 'Rechazado',
                    value: 'rechazado'
                }

            }
        })
    }

    function approve() {
        dispatcher('sendApproval', {
            id: item.id,
            status: {
                label: 'APROBAR',
                action: {
                    label: 'Aprobado',
                    value: 'aprobado'
                }
            }
        })
    }

    function showApproval() {
        if (item.approvalStatus?.value != 'pendiente') {
            dispatcher('showApproval', {
                id: item.id,
                date: item.approvalDate,
                status: {
                    action: item.approvalStatus
                },
                user: item.gaUser,
                comment: item.gaComment
            });
        }
    };




 export function rejecting(preciosFiltered: any, userInputTextMessage: any) {

    dispatcher('decodeProduct', {
        'items': preciosFiltered,
        'message': userInputTextMessage
    })

    
}

function modalConfirm() {
    preciosFiltered = precios.filter(x=> x.checkbox)
    preciosFiltered = preciosFiltered.map((x: { id: any; })=> x.id);

    if (preciosFiltered.length > 0) {
        let userInputTextMessage = prompt('¿Cual es el motivo por el cual desea rechazar la codificacion?:');
        if (userInputTextMessage !== null) {
            modalApp.openConfirmModal({
                title: 'Confirmación',
                message: '¿Estás seguro de que deseas rechazar la decodificación?',
                ok: 'ACEPTAR',
                cancel: 'CANCELAR',
                onAccept: () => {
                    rejecting(preciosFiltered, userInputTextMessage);
                    // closeModal();
                },
                onCancel: () => {
                    // closeModal();
                }
            });
        }
    }
    else{
        let message = "No hay items seleccionados"
        alert(message);
    }
}

    function validarCampo(campo: any) {

        return campo != undefined && campo != null ? campo: "No existe el campo"

    }
   
    

</script>

<div class="table1">
    <div style="display: flex; align-items: center;">
        <!-- Botón Anterior -->
        <div>
            <NauiButton
                size="small"
                caption="Anterior"
                mode="stroked"
                color="accent"
                on:click={() => updatePage(currentPage - 1)}
                download={currentPage === 1}
            ></NauiButton>
        </div>
    
        <!-- Botón Siguiente -->
        <div style="margin-left: 10px;">
            <NauiButton
                size="small"
                caption="Siguiente"
                mode="stroked"
                color="accent"
                on:click={() => updatePage(currentPage + 1)}
                download={endIndex >= nPages}
            ></NauiButton>
        </div>
    
        <!-- Contador de páginas -->
        <div style="margin-left: 10px;">
            <p>Página {currentPage} de {nPages}</p>
        </div>
        
        <!-- Select para seleccionar elementos por página -->
        <div style="margin-left: 10px;">
            <label for="itemsPerPageSelect">Items por página:</label>
            <select 
                bind:value={itemsPerPage}
                on:change={() => updatePage(1)} 
                id="itemsPerPageSelect">
            {#each itemsPerPageOptions as option}
                <option value={option}>{option}</option>
            {/each}
            </select>
        </div>

    </div>
    <table class="naui-table w-100 my-1">
        <thead>
            <tr>
                <th class="stickyHeader">
                    <div>
                        <NauiCheckbox bind:value={checkbox}
                        on:change={()=>{
                            precios.forEach(p=>p.checkbox = checkbox);
                            precios = [...precios]
                        }}/>
                    </div>
                </th>
                <th class="stickyHeader">
                    <div>item</div>
                </th>
                <th class="stickyHeader">
                    <div>Nombre solicitado por el cliente</div>
                </th>
                <th class="stickyHeader">
                    <div>Unidad de negocio</div>
                </th>
                <th class="sticky">
                    <div>Código | Descripción B.</div>
                </th>
                <th class="stickyHeader">
                    <div>Unidad de medida (UM)</div>
                </th>
                <th class="stickyHeader">
                    <div>Cantidad por UM</div>
                </th>
                <th class="stickyHeader">
                    <div>Cantidad Solicitada</div>
                </th>
                <th class="stickyHeader">
                    <div>Precio Actual cargado en SAP</div>
                </th>
                <th class="stickyHeader">
                    <div>Precio Anterior cargado en SAP</div>
                </th>
                <th class="stickyHeader">
                    <div>Precio vendido año anterior</div>
                </th>
                <th class="stickyHeader">
                    <div>Incremento sobre precio vendido año anterior</div>
                </th>
                <th class="stickyHeader">
                    <div>Precio minimo</div>
                </th>
                <th class="stickyHeader">
                    <div>Lista precio A</div>
                </th>
                <th class="stickyHeader">
                    <div>Lista precio B</div>
                </th>
                <th class="stickyHeader">
                    <div>Lista precio C</div>
                </th>
                <th class="stickyHeader">
                    <div>Precio Techo</div>
                </th>
                <th class="stickyHeader">
                    <div>Descuento Precio Techo</div>
                </th>
                <th class="stickyHeader">
                    <div>Precio de puja</div>
                </th>
                <th class="stickyHeader">
                    <div>Descuento precio puja</div>
                </th>
                <th class="stickyHeader">
                    <div>Costo Unitario</div>
                </th>
                <th class="stickyHeader">
                    <div>Costo UM</div>
                </th>
                <th class="stickyHeader">
                    <div>Costo total oferta</div>
                </th>
                {#if option_input !== "" }
                <th class="stickyHeader">
                    <div>Precio Unitario Sugerido 
                        <p><NauiButton size="small"
                            caption="Confirmar"
                            mode="stroked"
                            color="accent"
                            
                            on:click={()=>confirm()}/></p>
                    </div>
                    
                </th>
                {/if}
                <th class="stickyHeader">
                    <div>Precio Unitario</div>
                </th>
                <th class="stickyHeader">
                    <div>Precio UM </div>
                </th>
                <th class="stickyHeader">
                    <div>Valor total oferta</div>
                </th>
                <th class="stickyHeader">
                    <div>Margen Bruto %</div>
                </th>
                <th class="stickyHeader">
                    <div>Alerta Costo</div>
                </th>
                <th class="stickyHeader">
                    <div>Alerta Precio tipo A</div>
                </th>
                <th class="stickyHeader">
                    <div>Alerta % incremento directorio</div>
                </th>

                <th class="stickyHeader">
                    <div>Precio por Unidad de Medida (UM) a ofertar</div>
                </th>
                <th class="stickyHeader">
                    <div>Margen</div>
                </th>
                <th class="stickyHeader">
                    <div>Cantidad * UM</div>
                </th>
            </tr>
        </thead>
        <tbody>
            {#each precios as item}
                <tr>
                    <!-- checkbox -->
                    <td>
                        <div>
                            <NauiCheckbox bind:value={item.checkbox}>
                            </NauiCheckbox>
                        </div>
                    </td>
                    <!-- item -->
                    <td>
                        <div>{item.number ? item.number : ""}</div>
                    </td>
                    <!-- nombre solicitado por el cliente -->
                    <td>
                        <div>
                            <input
                                type="text"
                                readonly
                                class="naui-input w-100"
                                value={item.name}
                            />
                        </div>
                    </td>
                    <!--* unidad de negocio N/A -->
                    <td>
                       <div>{validarCampo(item.bu?.name)}</div>
                    </td>
                    <!-- codigo descripcion -->
                    <td class="sticky-2">
                        <div>
                            <input
                                type="text"
                                readonly
                                class="naui-input w-100px"
                                value={validarCampo(item?.product?.label)}
                            />
                        </div>
                    </td>
                    <!-- unidad de medida UM -->
                    <td>
                        <div>
                            {item?.product?.measurement_unit || 0}
                        </div>
                    </td>
                    <!-- cantidad por UM -->
                    <td>
                        <div>
                            {item?.product?.quantity_by_um || 0}
                        </div>
                    </td>
                    <!-- cantidad Solicitada-->
                    <td>
                        <div>
                            {item?.quantity}
                        </div>
                    </td>
                    <!-- Precio actual cargado en SAP-->
                    <td>
                        <div>
                            {currency.format(item.product?.sap?.current || 0)}
                        </div>
                    </td>
                    <!-- Precio anterior cargado en SAP-->
                    <td>
                        <div>
                            {currency.format(item.product?.sap?.previous || 0)}
                        </div>
                    </td>
                    <!-- Precio vendido año anterior-->
                    <td>
                        <div>
                            {currency.format(item.product?.sap?.priceSold || 0)}
                        </div>
                    </td>
                    <!-- % incremento sobre precio vendido año anterior-->
                    <td>
                        <div>
                            {percent.format(item.IncreasePriceSoldPreviousYear|| 0)}
                        </div>
                    </td>
                    <!-- precio minimo -->
                    <td>
                        <div>
                            {currency.format(item?.product?.min_price||0)}
                        </div>
                    </td>
                    <!-- Lista precio A -->
                    <td>
                        <div>
                            {currency.format(item.product?.abc?.A || 0)}
                        </div>
                    </td>
                    <!-- Lista precio B -->
                    <td>
                        <div>
                            {currency.format(item.product?.abc?.B || 0)}
                        </div>
                    </td>
                    <!-- Lista precio C -->
                    <td>
                        <div>
                            {currency.format(item.product?.abc?.C || 0)}
                        </div>
                    </td>
                    <!-- Precio techo -->
                    <td>
                        <div>
                            {currency.format(item.roof)}
                        </div>
                    </td>
                    <!-- Descuento precio techo  -->
                    <td>
                        <div>
                            {percent.format(item.discountCeilingPrice)}
                        </div>
                    </td>
                    <!-- Precio puja -->
                    <td>
                        <div>
                            {#if !editable || item.isDisabled}
                                <div class="naui-input w-100 pt-ii">
                                    {currency.format(item.bidPrice)}
                                </div>
                            {:else}
                                <input
                                    type="number"
                                    class="naui-input w-100"
                                    readonly={!editable || item.isDisabled}
                                    on:change
                                    on:input
                                    bind:value={item.bidPrice}
                                />
                            {/if}
                        </div>
                    </td>
                    <!-- Descuento precio puja -->
                    <td>
                        <div>
                            {percent.format(item.discountBidPrice)}
                        </div>
                    </td>
                    <!-- Costo Unitario -->
                    <td>
                        <div>
                            {currency.format(item.unitCost)}
                        </div>
                    </td>
                    <!-- Costo UM -->
                    <td>
                        <div>
                            {currency.format(item.muCost)}
                        </div>
                    </td>
                    <!-- Costo Total oferta -->
                    <td>
                        <div>
                            {currency.format(item.totalCost)}
                        </div>
                    </td>
                    <!-- Precio Sugerido -->
                    {#if option_input !== "" }
                    <td>
                        <div>
                           
                           <input type="number"
                           bind:value={ item._suggestedMUOfferPrice}>
                          
                        </div>
                    </td>
                    {/if}
                    <!--* Precio Unitario -->
                    <td>
                        <div>
                            {#if !editable || item.isDisabled || !item.checkbox } 
                            <NauiField label="Precio unitario"
                                       className="mb-1"
                                       value={currency.format(item.unitOfferPrice)}/>
                            
                        {:else}
                            <NauiInput className="mb-1"
                                       alert={item.alert}
                                       type="number"
                                       label="Precio unitario"
                                       isDisabled={!editable || item.isDisabled}
                                       on:change={()=>dispatcher('update')}
                                       on:input
                                       alertMessage={item.unitOfferErrorMessage}
                                       bind:value={item.unitOfferPrice}/>
                                       
                        {/if}
                                
                        </div>
                    </td>
                    <!-- Precio UM -->
                    <td>
                        <div>
                            <NauiInput label="Precio UM"
                            className="mb-1"
                            isDisabled={!editable || item.isDisabled}
                            bind:value={item.muOfferPrice}/>
                        </div>
                    </td>
                    <!-- Valor total oferta -->
                    <td>
                        <div>
                            {currency.format(item.totalValueOffer)}
                        </div>
                    </td>
                    <!-- Margen Bruto % -->
                    <td>
                        <div>
                            {percent.format(item.margin / 100)}
                        </div>
                    </td>
                    <!-- Alerta costo-->
                    <td>
                        <div>
                            {validateAlert(item.costError) }
                        </div>
                    </td>
                    <!-- Alerta Precio tipo A-->
                    <td>
                        <div>
                            {validateAlert(item.abcPricesListA)}
                        </div>
                    </td>
                    <!-- Alerta % incremento directorio-->
                    <td>
                        <div>
                            {validateAlert(item.abcPricesIncrementoDirectorio)}
                        </div>
                    </td>
                    <!-- precio por unidad de medida UM a ofertar-->
                    <td>
                        <div>
                            {#if !editable || item.isDisabled}
                                <div class="naui-input w-100 pt-ii">
                                    {currency.format(item.unitOfferPrice)}
                                </div>
                            {:else}
                                <input
                                    type="number"
                                    class="naui-input w-100"
                                    class:alert={item.showAlert && editable}
                                    readonly={!editable || item.isDisabled}
                                    on:change
                                    on:input
                                    bind:value={item.unitOfferPrice}
                                />
                            {/if}
                        </div>
                    </td>
                    <!-- margen -->
                    <td>
                        <div>
                            <input
                                type="text"
                                readonly
                                class="naui-input w-100"
                                value={percent.format(item.margin / 100)}
                            />
                        </div>
                    </td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>
<div class="apply">
    
  
                    <div>
                        <label for="price-A">
                            <input 
                            name="selected"
                            value="price-A"
                            id="price-A"
                            bind:group={option_input}
                            type="radio"/>
                        </label>    
                    </div>
                    <p class="radio">Seleccionar precio A</p><br>
                    <div>
                        <label for="price-B">
                            <input 
                            name="selected"
                            value="price-B"
                            id="price-B"
                            bind:group={option_input}
                            type="radio"/>
                        </label> 
                    </div>
                    <p class="radio">Seleccionar precio B</p><br>
                    <div>
                        <label for="price-C">
                            <input 
                            name="selected"
                            value="price-C"
                            id="price-C"
                            bind:group={option_input}
                            type="radio"/>
                        </label> 
                    </div>
                    <p class="radio">Selecccionar precio C</p><br>
                    <div>
                        <label for="price-Min">
                            <input 
                            name="selected"
                            value="price-Min"
                            id="price-Min"
                            bind:group={option_input}
                            type="radio"/>
                        </label> 
                    </div>
                    <p class="radio">Selecccionar precio tipo Mínimo</p><br>

                    <div>
                        <label for="incremento-directorio">
                            <input 
                            name="selected"
                            value="incremento-directorio"
                            id="incremento-directorio"
                            bind:group={option_input}
                            type="radio"/>
                        </label>    
                    </div>
                    <p class="radio">Seleccionar incremento directorio</p><br>
                
                    <div>
                        <label for="incremento-manual-directorio">
                            <input 
                            name="selected"
                            value="incremento-manual-directorio"
                            id="incremento-manual-directorio"
                            bind:group={option_input}
                            type="radio"/>
                        </label>    
                    </div>
                    <p class="radio">Seleccionar incremento manual directorio</p><br>

                    {#if option_input == "incremento-manual-directorio"}
                        <input type="number"
                        bind:value={manual_increment}
                        >
                    {/if}

                    <div>
                        <label for="precio-general">
                            <input 
                            name="selected"
                            value="precio-general"
                            id="precio-general"
                            bind:group={option_input}
                            type="radio"/>
                        </label>    
                    </div>
                    <p class="radio">Seleccionar Tipo Precio General</p><br>
                 
</div>


<div class="aplicar">
    <div>
        <NauiButton caption="APLICAR"
                    icon="save"
                    color="accent"
                    mode="solid"
                    
                    on:click={applyConfirm}/>
    </div>

    <div class="rechazar">                                  
    <NauiButton caption="RECHAZAR"
                   
                    color="primary"
                    mode="solid"
                    on:click={modalConfirm}/>             
    </div>
</div>




<style>
    .table1 {
        max-height: 350px;
        max-width: 93vw;
        overflow-x: scroll;
    }
    .sticky {
        position: sticky;
        left: 0;
        top: 0;
        background-color: var(--back-gray);
        z-index: 3;
        z-index: 4;
    }

    .sticky-2 {
        position: sticky;
        left: 0;
        background-color: white;
        z-index: 2;
    }

    .stickyHeader {
        position: sticky;
        top: 0;
        background-color: var(--back-gray);
        z-index: 3;
    }

    .apply {
        align-items: center;
        margin-top: 25px;
        box-sizing: border-box;
        
        height: 100px;
        
    }

    .apply .radio  {
        justify-content: center;
        height: 5px;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        margin-top: -25px;
        
    }

    .aplicar {
        margin-top: 250px;
        display: flex;
        flex-direction: row;
        
    }
    .aplicar .rechazar {
       margin-left: 20px;
    }

    p {
        
        margin-left: 35px;
    }
    


    
</style>
